import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoffee = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-coffee-icon lucide-coffee",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 2v2" })
	]
});
export default SvgCoffee;
